'use strict';

module.exports = require('string-at');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es7-shim/String.prototype.at.js
// module id = 804
// module chunks = 0